module.exports = __webpack_public_path__ + "img/semicircle-bottom-white.0718ee78.svg";